
export default {
    //第三页面
    CoumonthFrom:'',
    CoumonthTo:'',
    CouBrand:'',
    //竞争类型
    CouCateGory1:'',
    //风格榜
    CouCateGory2:'',
    //第二页面
    ComBrand:'',
    ComCateGory2:'',
    ComCateGory1:'',
    ComCateGory3:'',
    ComMonthFrom:'',
    ComMonthTo:'',
    PlatForm:'',
    ComMyFlag:'',
    //第一页面
    monthFrom:'',
    monthTo:'',
    Brand:'',
    CateGory1:'',
    CateGory2:'',
    MyFlag:''
};


// WEBPACK FOOTER //
// ./src/store/state.js